import { countConversationsResolved } from './countConversationsResolved'
import { atLeastOneReply } from './filters'

export const countConversationsResolvedWithAtLeastOneReply = {
  ...countConversationsResolved,
  filters: [atLeastOneReply],
  key: 'countConversationsResolvedWithAtLeastOneReply',
}
